import { connect } from 'react-redux'
import { logout } from '../../actions/auth'
import LoggedInBlock from './LoggedInBlock'

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        logout: (data) => {
            dispatch(logout())
        },
    }
}

const LoggedInBlockContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoggedInBlock)

export default LoggedInBlockContainer
